export default "__VITE_ASSET__a970b43f__"